$.fn.isInViewport = function () {
  let elementTop = $(this).offset().top;
  let viewportTop = $(window).scrollTop();

  const windowHeight = $(window).height();

  return viewportTop >= elementTop - windowHeight / 3;
};

$(function () {
  const smartSuggestion = {
    init() {
      smartSuggestion.create();
    },
    create() {
      const ele = $("[data-smart-suggestions]");
      if (ele.length == 0) return;

      const eleTriggerDisplay = $("[data-trigger-smart-suggestions]");

      eleTriggerDisplay.each(function () {
        const section = $(this);

        if (section.isInViewport()) {
          ele.stop().fadeIn();
          if ($("#tln-cbwg-widget").length) {
            $("#tln-cbwg-widget").addClass("display-with-smart-suggestions")
          };

          // Close chatbox if we open the suggestions box
          window.TaliaChatWidget.hideChatBox()
        }
      });

      $(window).scroll(function () {
        if (eleTriggerDisplay.length !== 0) {
          eleTriggerDisplay.each(function () {
            const section = $(this);

            if (section.isInViewport() && !ele.hasClass('dirty')) {
              ele.addClass('dirty opened');
              ele.stop().fadeIn();
              ele.find('[data-results]').stop().fadeIn();
              if ($("#tln-cbwg-widget").length) {};
              $("#tln-cbwg-widget").addClass("display-with-smart-suggestions")

              // Close chatbox if we open the suggestions box
              window.TaliaChatWidget.hideChatBox()
            }
          });
        }
      });

      ele.on("click", "[data-toggle-display]", function () {
        const self = $(this);
        const action = self.data("toggle-display");

        if (action === "open") {
          self.closest("[data-smart-suggestions]").addClass("opened");
          self
            .closest("[data-smart-suggestions]")
            .find("[data-results]")
            .stop()
            .fadeIn();

          $("[data-overlay]").stop().fadeIn();

          // Close chatbox if we open the suggestions box
          window.TaliaChatWidget.hideChatBox()
        } else {
          self.closest("[data-smart-suggestions]").removeClass("opened");
          self
            .closest("[data-smart-suggestions]")
            .find("[data-results]")
            .stop()
            .fadeOut();

          $("[data-overlay]").stop().fadeOut();
          $('[data-cta-supports]').removeClass('active').removeClass('no-active');
        }
      });

      eleTriggerDisplay.each(function () {
        const section = $(this);

        if (section.isInViewport()) {
          ele.stop().fadeIn();
          if ($("#tln-cbwg-widget").length) {
            $("#tln-cbwg-widget").addClass("display-with-smart-suggestions")
          }
        }
      });

      $(document).mouseup(function (e) {
        const container = $("[data-smart-suggestions] [data-results]");

        if (
          !container.is(e.target) &&
          container.has(e.target).length === 0 &&
          container.closest("[data-smart-suggestions]").hasClass("opened")
        ) {
          container.closest("[data-smart-suggestions]").removeClass("opened");
          container.stop().fadeOut();
          $('[data-overlay]').stop().fadeOut();
          $('[data-cta-supports]').removeClass('active').removeClass('no-active');
          $('[data-cta-supports]').removeClass('active');
        }
      });
    },
  };

  smartSuggestion.init();
});
